var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PacemEventTarget, Watch, PropertyConverters, Utils } from './_default-imports';
//namespace Pacem.Components {
let PacemWebWorkerProxyElement = class PacemWebWorkerProxyElement extends PacemEventTarget {
    constructor() {
        super(...arguments);
        this.autosend = true;
        this._messageHandler = (evt) => {
            this.result = evt.data;
            this.dispatchEvent(new CustomEvent('receive', { detail: evt.data, bubbles: false, cancelable: false }));
        };
        this._errorHandler = (evt) => {
            this.dispatchEvent(new CustomEvent('error', { detail: evt.error, bubbles: false, cancelable: false }));
        };
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._initializeWorker();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'src':
                    this._disposeWorker();
                    this._initializeWorker(val);
                    break;
                case 'autosend':
                case 'disabled':
                case 'message':
                    if (this.autosend) {
                        this.send(this.message);
                    }
                    break;
            }
        }
    }
    disconnectedCallback() {
        this._disposeWorker();
        super.disconnectedCallback();
    }
    send(message = this.message) {
        if (this.disabled) {
            return;
        }
        const worker = this._worker;
        if (!Utils.isNull(worker)) {
            worker.postMessage(message);
        }
    }
    _initializeWorker(src = this.src) {
        if (!Utils.isNullOrEmpty(src)) {
            const worker = this._worker = new Worker(src);
            worker.addEventListener('message', this._messageHandler, false);
            worker.addEventListener('error', this._errorHandler, false);
            if (this.autosend && !Utils.isNull(this.message)) {
                this.send();
            }
        }
    }
    _disposeWorker(worker = this._worker) {
        if (!Utils.isNull(worker)) {
            worker.removeEventListener('error', this._errorHandler, false);
            worker.removeEventListener('message', this._messageHandler, false);
            worker.terminate();
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemWebWorkerProxyElement.prototype, "message", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemWebWorkerProxyElement.prototype, "result", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemWebWorkerProxyElement.prototype, "src", void 0);
__decorate([
    Watch({ emit: false, reflectBack: true, converter: PropertyConverters.Boolean })
], PacemWebWorkerProxyElement.prototype, "autosend", void 0);
PacemWebWorkerProxyElement = __decorate([
    CustomElement({ tagName: P + '-webworker-proxy' })
], PacemWebWorkerProxyElement);
export { PacemWebWorkerProxyElement };
//}
